<template>
  <section-layout
    :disabled="!cambiado || loading"
    :loading="loading || saving"
    :showButton="false"
  >
    <template v-slot:title>
      {{localization.tabsTitles.web}}
    </template>
    <template v-slot:content>

      <v-row align="center" dense class="mt-3">
        <v-col
          cols="12"
        >
        <v-checkbox v-model="configuracion.clientesVerWeb"
            id="clientesVerWeb"
            color="primary" hide-details
            :disabled="saving"
            @change="updateCambiado(true)"
        >
          <template v-slot:label>
            <div><strong>{{ localization.portal.clientesVerWeb}}</strong></div>
          </template>
        </v-checkbox>
          </v-col>
      </v-row>

      <v-row align="center" dense>
        <v-col cols="1">

        </v-col>
        <v-col cols="11">
          <v-checkbox v-model="configuracion.clienteCrearIncidenciasWeb"
            id="clienteCrearIncidenciasWeb"
            :label="localization.portal.clienteCrearIncidenciasWeb"
            color="primary" hide-details
            :disabled="saving || configuracion.clientesVerWeb=== false"
            @change="updateCambiado(true)"
          />
        </v-col>
      </v-row>

      <v-row align="center" dense>
        <v-col cols="2">

        </v-col>
        <v-col cols="10">
          <v-checkbox
            v-model="configuracion.mostrarOficioWeb"
            id="mostrarOficioWeb"
            :label="localization.portal.mostrarOficioWeb"
            color="primary"
            hide-details
            :disabled="saving || configuracion.clienteCrearIncidenciasWeb === false || configuracion.clientesVerWeb === false"
            @change="updateCambiado(true)"
          />
        </v-col>
      </v-row>
      <v-row align="center" dense>
        <v-col cols="1">

        </v-col>
        <v-col cols="11">
          <v-checkbox  v-model="configuracion.mostrarObservacionesWeb"
            id="mostrarObservacionesWeb"
            :label="localization.portal.mostrarObservacionesWeb"
            color="primary" hide-details
            @change="updateCambiado(true)"
            :disabled="saving || configuracion.clientesVerWeb === false"
          />
        </v-col>
      </v-row>


      <v-row align="center" dense>
         <v-col cols="1">
          <!-- <p>hola</p> -->
        </v-col>
        <v-col cols="11">
          <v-select v-model="configuracion.tipoVisitaIncidenciaWeb"
            id="tipoVisitaIncidenciaWeb"
            :items="tiposVisitaIncidencia"
            :item-text="item => `${ item.translates && item.translates[usuario.idioma] !== undefined && item.translates[usuario.idioma] !== null ? item.translates[usuario.idioma] : ''  }`"
            item-value="code"
            :label="localization.portal.tipoVisitaIncidenciaWeb"
            multiple chips deletable-chips clearable
            :hint="localization.portal.tipoVisitaIncidenciaWeb"
            persistent-hint color="primary"
            @change="borrarPromocionesTiposVisita();updateCambiado(true)"
            :disabled="saving || configuracion.clientesVerWeb === false"
          />
        </v-col>
      </v-row>
      <v-row v-for="itemTipoVisita in configuracion.tipoVisitaIncidenciaWeb" :key="itemTipoVisita" align="center" dense>
        <v-col cols="2">

        </v-col>
        <v-col cols="8">
          <div @click="mostrarPopupPromociones(itemTipoVisita)" >
            <v-autocomplete v-if="itemTipoVisita == 1" :no-data-text="$t('sinDatos')"
              v-model="configuracion.promocionesTipoVisitaWeb.preVenta" id="promocionesPreVenta"
              :items="promociones"
              :label="$t('sectionConfiguracion.portal.promocionesTiposVisitaIncidencia', {tipoVisita: getNameTipoVisita(itemTipoVisita)})"
              :hint="$t('sectionConfiguracion.portal.promocionesTiposVisitaIncidencia', {tipoVisita: getNameTipoVisita(itemTipoVisita)})"
              item-value="id"
              item-text="nombreCompleto"
              :disabled="saving || configuracion.clientesVer === false"
              readonly
              multiple
              @change="popupPromociones($event)"
              >
            </v-autocomplete>
            <v-autocomplete v-if="itemTipoVisita == 2" :no-data-text="$t('sinDatos')"
              v-model="configuracion.promocionesTipoVisitaWeb.postVenta" id="promocionespostVenta"
              :items="promociones"
              :label="$t('sectionConfiguracion.portal.promocionesTiposVisitaIncidencia', {tipoVisita: getNameTipoVisita(itemTipoVisita)})"
              :hint="$t('sectionConfiguracion.portal.promocionesTiposVisitaIncidencia', {tipoVisita: getNameTipoVisita(itemTipoVisita)})"
              item-value="id"
              item-text="nombreCompleto"
              :disabled="saving || configuracion.clientesVer === false"
              readonly
              multiple
              @change="popupPromociones($event)"
              >
            </v-autocomplete>
            <v-autocomplete v-if="itemTipoVisita == 3" :no-data-text="$t('sinDatos')"
              v-model="configuracion.promocionesTipoVisitaWeb.preEntrega" id="promocionesPreEntrega"
              :items="promociones"
              :label="$t('sectionConfiguracion.portal.promocionesTiposVisitaIncidencia', {tipoVisita: getNameTipoVisita(itemTipoVisita)})"
              :hint="$t('sectionConfiguracion.portal.promocionesTiposVisitaIncidencia', {tipoVisita: getNameTipoVisita(itemTipoVisita)})"
              item-value="id"
              item-text="nombreCompleto"
              :disabled="saving || configuracion.clientesVer === false"
              readonly
              multiple
              @change="popupPromociones($event)"
              >
            </v-autocomplete>
          </div>
        </v-col>
      </v-row>

      <v-row>
         <v-col cols="1">

        </v-col>
        <v-col cols="11">
          <v-label>{{ localization.portal.diasVisibleClienteWeb }}</v-label>
          <div class="contenedorTextField">
            <v-text-field
              v-model="configuracion.diasVisibleClienteWeb"
              id="diasVisibleClienteWeb"
              :rules="[rules.integerNumber0]"
              color="primary"
              :disabled="saving || configuracion.clientesVerWeb === false"
              @change="updateCambiado(true)"
            />
          </div>
        </v-col>
      </v-row>
      <v-row align="center" dense>
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <v-checkbox
            v-model="configuracion.ocultarProveedorHoras"
            id="ocultarProveedorHoras"
            :label="localization.portal.ocultarProveedorHoras"
            color="primary"
            hide-details
            :disabled="saving || configuracion.clientesVerWeb === false"
            @change="updateCambiado(true)"
          />
        </v-col>
      </v-row>
      <v-row align="center" dense>
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <v-checkbox
            v-model="configuracion.ocultarResponsable"
            id="ocultarResponsable"
            :label="localization.portal.ocultarResponsable"
            color="primary"
            hide-details
            :disabled="saving || configuracion.clientesVerWeb === false"
            @change="updateCambiado(true)"
          />
        </v-col>
      </v-row>

      <v-row>
         <v-col cols="1"></v-col>
      </v-row>

      <o-big-title justify="start"></o-big-title>

      <v-row align="center" dense>
        <v-col
          cols="12"
        >
        <v-checkbox v-model="configuracion.habilitarOpcionesConformidadWeb"
            id="habilitarOpcionesConformidadWeb"
            color="primary" hide-details
            @change="updateCambiado(true)"
            :disabled="saving || configuracion.clientesVerWeb=== false"
        >
          <template v-slot:label>
            <div><strong>{{ localization.portal.habilitarOpcionesConformidadWeb }}</strong></div>
          </template>
        </v-checkbox>
          </v-col>
      </v-row>

      <v-row align="center" dense>
        <v-col cols="1">

        </v-col>
        <v-col cols="11">
          <v-checkbox v-model="configuracion.desdeTerminadoWeb"
            id="desdeTerminadoWeb"
            :label="localization.portal.desdeTerminadoWeb"
            color="primary" hide-details
            @change="updateCambiado(true)"
            :disabled="saving || configuracion.habilitarOpcionesConformidadWeb === false || configuracion.clientesVerWeb=== false"
          />
        </v-col>
      </v-row>


      <v-row align="center" dense>
        <v-col cols="2">

        </v-col>
        <v-col cols="10">
          <v-checkbox v-model="configuracion.clientesRechazarDesdeTerminadoWeb"
            id="clientesRechazarDesdeTerminadoWeb"
            :label="localization.portal.clientesRechazarWeb"
            color="primary" hide-details
            :disabled="saving || configuracion.desdeTerminadoWeb === false || configuracion.habilitarOpcionesConformidadWeb === false || configuracion.clientesVerWeb=== false"
            @change="updateCambiado(true)"
          />
        </v-col>

      </v-row>


      <v-row align="center" dense>
        <v-col cols="2">
        </v-col>
        <v-col cols="10">
          <v-checkbox v-model="configuracion.clientesCerrarDesdeTerminadoWeb"
            id="clientesCerrarDesdeTerminadoWeb"
            :label="localization.portal.clientesCerrarWeb"
            color="primary" hide-details
            :disabled="saving || configuracion.desdeTerminadoWeb === false || configuracion.habilitarOpcionesConformidadWeb === false || configuracion.clientesVerWeb=== false"
            @change="updateCambiado(true)"
          />
        </v-col>
      </v-row>


      <v-row align="center" dense>
        <v-col cols="1">

        </v-col>
        <v-col cols="11">
          <v-checkbox v-model="configuracion.configVistoBuenoClienteWeb"
            id="configVistoBuenoClienteWeb"
            :label="localization.portal.desdeVBCliente"
            color="primary" hide-details
            @change="updateCambiado(true)"
            :disabled="saving || configuracion.habilitarOpcionesConformidadWeb === false || configuracion.clientesVerWeb=== false"
          />
        </v-col>
      </v-row>


      <v-row align="center" dense>
        <v-col cols="2">

        </v-col>
        <v-col cols="10">
          <v-checkbox v-model="configuracion.clientesRechazarDesdeVB_WEB"
            id="clientesRechazarDesdeVB_WEB"
            :label="localization.portal.clientesRechazar"
            color="primary" hide-details
            :disabled="saving || configuracion.configVistoBuenoClienteWeb === false || configuracion.habilitarOpcionesConformidadWeb === false || configuracion.clientesVerWeb=== false"
            @change="updateCambiado(true)"
          />
        </v-col>

      </v-row>


      <v-row align="center" dense>
        <v-col cols="2">
        </v-col>
        <v-col cols="10">
          <v-checkbox v-model="configuracion.clientesCerrarDesdeVB_WEB"
            id="clientesCerrarDesdeVB_WEB"
            :label="localization.portal.clientesCerrarWeb"
            color="primary" hide-details
            :disabled="saving || configuracion.configVistoBuenoClienteWeb === false || configuracion.habilitarOpcionesConformidadWeb === false || configuracion.clientesVerWeb=== false"
            @change="updateCambiado(true)"
          />
        </v-col>
      </v-row>

      <v-row align="center" dense>
        <v-col cols="3">

        </v-col>
        <v-col cols="9">
          <v-label>{{ localization.portal.diasCierreWeb }}</v-label>
          <div class="contenedorTextField">
             <v-text-field
              dense
              v-model="configuracion.diasCierreWeb"
              id="diasCierreWeb"
              :rules="[rules.integerNumber1]"
              color="primary"
              :disabled="saving || configuracion.habilitarOpcionesConformidadWeb === false || configuracion.clientesRechazarWeb === false || configuracion.configVistoBuenoClienteWeb === false || configuracion.clientesVerWeb=== false"
              @change="updateCambiado(true)"
            ></v-text-field>
          </div>

        </v-col>

      </v-row>

      <v-row v-if="origenestadoytipovisibles" align="center" dense>
        <v-col cols="12">
          <v-select v-model="configuracion.origenIncidenciaWeb"
            id="origenIncidenciaWeb"
            :items="configuracion.origenIncidenciaWeb"
            :label="localization.portal.origenIncidenciaWeb"
            multiple chips deletable-chips clearable
            :hint="localization.portal.origenIncidenciaWeb"
            persistent-hint color="primary" :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
      </v-row>
      <v-row v-if="origenestadoytipovisibles" align="center" dense>
        <v-col cols="12">
          <v-select v-model="configuracion.estadoIncidenciaWeb"
            id="estadoIncidenciaWeb"
            :items="configuracion.estadoIncidenciaWeb"
            :label="localization.portal.estadoIncidenciaWeb"
            multiple chips deletable-chips clearable
            :hint="localization.portal.estadoIncidenciaWeb"
            persistent-hint color="primary" :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
      </v-row>
      <v-row v-if="origenestadoytipovisibles" align="center" dense>
        <v-col cols="12">
          <v-select v-model="configuracion.tipoVisitaIncidenciaWeb"
            id="tipoVisitaIncidenciaWeb"
            :items="configuracion.tipoVisitaIncidenciaWeb"
            :label="localization.portal.tipoVisitaIncidenciaWeb"
            multiple chips deletable-chips clearable
            :hint="localization.portal.tipoVisitaIncidenciaWeb"
            persistent-hint color="primary" :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
      </v-row>


      <o-big-title justify="start" class="mt-3"></o-big-title>


      <v-row align="center" dense>
        <v-col
          cols="12"
        >
        <v-checkbox v-model="configuracion.PV_CLIENTE_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR"
            id="PV_CLIENTE_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR"
            color="primary" hide-details
            :disabled="saving || configuracion.clientesVerWeb=== false"
            @change="updateCambiado(true)"
        >
          <template v-slot:label>
            <div>{{ localization.portal.PV_CLIENTE_NOTIFICAR_ALTA_INCIDENCIAS_SUPERVISOR }}</div>
          </template>
        </v-checkbox>
          </v-col>
      </v-row>

      <v-row align="center" dense>
        <v-col
          cols="12"
        >
        <v-checkbox v-model="configuracion.PV_BLOQUEO_CAMPO_DESCRIPCION_WEB"
            id="PV_BLOQUEO_CAMPO_DESCRIPCION_WEB"
            color="primary" hide-details
            :disabled="saving || configuracion.clientesVer === false"
            @change="updateCambiado(true)"
        >
          <template v-slot:label>
            <div>{{ localization.portal.PV_BLOQUEO_CAMPO_DESCRIPCION }}</div>
          </template>
        </v-checkbox>
          </v-col>
      </v-row>

      <v-fade-transition>
        <custom-dialog
          v-if="mostrarSeleccionarPromociones"
          v-model="mostrarSeleccionarPromociones" id="mostrarSeleccionarPromociones"
        >
          <PopUpSeleccionarPromociones
            :multiple="true"
            @selected="popupSeleccionarPromociones($event)"
            :yaSeleccionado="promocionesSelectedPopUp"
          />
        </custom-dialog>
      </v-fade-transition>
    </template>
  </section-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import PopUpSeleccionarPromociones from '../incidencias/maestros/PopUpSeleccionarPromociones'

export default {
  components: {
    PopUpSeleccionarPromociones
  },
  mixins: [rulesMixin],
  props: {
    saving: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    cambiado: {
      type: Boolean,
      default: false
    },
    configuracion: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      origenestadoytipovisibles: false,
      itemTipoVisita: null,
      idubapi: JSON.parse(localStorage.idubapi),
      mostrarSeleccionarPromociones: false,
      itemTipoVisitaActual: null,
      promocionesPreVenta: [],
      promocionespostVenta: [],
      promocionesPreEntrega: [],
      promocionesSelectedPopUp: []
    }
  },
  computed: {
    ...mapGetters({
      tiposVisitaIncidencia: 'incidencias/getTiposVisita'
    }),

    tiposVisitaIncidencia_not () {
      let tiposVisita = this.$store.state.incidencias.tipoVisita
      // filtramos para que solo aparezcan las que están en la pestaña general
      // this.configuracion.tiposIncidenciaSinOperacion
      // this.configuracion.tiposIncidenciaAlquiler
      // this.configuracion.tiposIncidenciaVenta
      // obtenemos de las 3 claves, los que están habilitados
      let tiposVisitaValidos = [
        ...new Set(
          [
            ...this.configuracion.tiposIncidenciaSinOperacion, 
            ...this.configuracion.tiposIncidenciaAlquiler, 
            ...this.configuracion.tiposIncidenciaVenta
          ]
        )
      ];
      tiposVisitaValidos = tiposVisitaValidos.map(x => parseInt(x))
      
      // devolvemos solo los que aparezcan
      tiposVisita = tiposVisita.filter(x => {
        // return tiposVisitaValidos.includes(parseInt(x.code))
        return tiposVisitaValidos.includes(parseInt(x.code))
      })
      return tiposVisita
    },
    tiposSolicitudes() {
      return (this.configuracion.tiposSolicitudes.length > 0 ) ?  this.configuracion.tiposSolicitudes.filter(x => x.habilitar === true) : []
    },
    promociones () {
      if (this.$store.state.incidencias.promociones) {
        return this.$store.state.incidencias.promociones.map(x => {
          return {
            ...x,
            nombreCompleto: (this.idubapi.motor === 'SQLSERVER') ? x.name + ' - ' + x.code : x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    translates() {
      if (this.$store.state.incidencias.translates) {
        return this.$store.state.incidencias.translates;
      }
      return [];
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    localization () {
      return this.$t('sectionConfiguracion')
    }
  },
  methods: {
    ...mapActions({
      getPropertiesDevelopment: 'incidencias/getPropertiesDevelopment'
    }),
    updateCambiado (val) {
      // this.cambiado = val
      this.$emit('cambiado', val)
    },
    formatearEstructuraPromocionesPopUp() {
      let promociones = this.promociones
      if ( this.itemTipoVisitaActual == 1) {
        if (  this.configuracion.promocionesTipoVisitaWeb.preVenta && this.configuracion.promocionesTipoVisitaWeb.preVenta.length > 0) {
          this.promocionesSelectedPopUp = this.configuracion.promocionesTipoVisitaWeb.preVenta.map ( function (x) {  
            return promociones.find( (promocion) => promocion.id == x.id ) 
          })
        } else {
          return []
        }
        
      }
      if ( this.itemTipoVisitaActual == 2) {
        if ( this.configuracion.promocionesTipoVisitaWeb.postVenta && this.configuracion.promocionesTipoVisitaWeb.postVenta.length > 0) {
          this.promocionesSelectedPopUp = this.configuracion.promocionesTipoVisitaWeb.postVenta.map ( function (x) {  
            return promociones.find( (promocion) => promocion.id == x.id ) 
          })
        } else {
          return []
        }
      }
      if ( this.itemTipoVisitaActual == 3) {
        if ( this.configuracion.promocionesTipoVisitaWeb.preEntrega && this.configuracion.promocionesTipoVisitaWeb.preEntrega.length > 0) {
          this.promocionesSelectedPopUp = this.configuracion.promocionesTipoVisitaWeb.preEntrega.map ( function (x) {  
            return promociones.find( (promocion) => promocion.id == x.id ) 
          })
          console.log("promocionesSelectedPopUp", this.promocionesSelectedPopUp)
        } else {
          return []
        }
      }
    },
    borrarPromocionesTiposVisita() {
      if ( this.configuracion.tipoVisitaIncidenciaWeb.find(x => x == 1) === undefined) {
        this.configuracion.promocionesTipoVisitaWeb.preVenta = []
      }
      if ( this.configuracion.tipoVisitaIncidenciaWeb.find(x => x == 2) === undefined) {
        this.configuracion.promocionesTipoVisitaWeb.postVenta = []
      }
      if ( this.configuracion.tipoVisitaIncidenciaWeb.find(x => x == 3) === undefined) {
        this.configuracion.promocionesTipoVisitaWeb.preEntrega = []
      }
    },
    mostrarPopupPromociones (itemTipoVisita) {
      this.itemTipoVisitaActual = itemTipoVisita
      this.formatearEstructuraPromocionesPopUp()

      if ( this.mostrarSeleccionarPromociones === false ) {
        this.mostrarSeleccionarPromociones = true
      }
      else {
        this.mostrarSeleccionarPromociones = false
      }
      this.updateCambiado(true)
    },
    popupSeleccionarPromociones (promocionesSelected) {
      if ( this.itemTipoVisitaActual == 1) {
        this.configuracion.promocionesTipoVisitaWeb.preVenta = (promocionesSelected != null && promocionesSelected.length > 0 ? promocionesSelected.map( x => x) : []) 
      }
      if ( this.itemTipoVisitaActual == 2) {
        this.configuracion.promocionesTipoVisitaWeb.postVenta = (promocionesSelected != null && promocionesSelected.length > 0 ? promocionesSelected.map( x => x) : []) 
      }
      if ( this.itemTipoVisitaActual == 3) {
        this.configuracion.promocionesTipoVisitaWeb.preEntrega = (promocionesSelected != null && promocionesSelected.length > 0 ? promocionesSelected.map( x => x) : []) 
      }  
      console.log(this.configuracion.promocionesTipoVisitaWeb)
    },
    getNameTipoVisita(codigoTipoVisita) {
      return this.$store.state.incidencias.tipoVisita.find(x => x.code === codigoTipoVisita).translates[this.usuario.idioma]
    },
    checkDisableSolicitudDiasCierre () {
      if (this.configuracion.diasCierreWeb <= 0 || this.configuracion.diasCierreWeb === null) {
        this.configuracion.configVistoBuenoClienteWeb = false
      }
    },
    desactivarVistoBuenoCliente() {
      this.configuracion.configVistoBuenoClienteWeb = false
      this.configuracion.clientesCerrarDesdeVB_WEB = false
      this.configuracion.clientesRechazarDesdeVB_WEB = false
    },
    desactivarTerminada() {
      this.configuracion.desdeTerminadoWeb = false
      this.configuracion.clientesCerrarDesdeTerminadoWeb = false
      this.configuracion.clientesRechazarDesdeTerminadoWeb = false
    },
    desactivarTodo() {
      this.desactivarVistoBuenoCliente()
      this.desactivarTerminada()
      this.configuracion.clienteCrearIncidenciasWeb = false
      this.configuracion.mostrarOficioWeb = false
      this.configuracion.mostrarObservacionesWeb = false
      this.configuracion.habilitarOpcionesConformidadWeb = false
    }
  },
  async mounted() {
    await this.getPropertiesDevelopment()
    console.log("this.configuracion", this.configuracion.promocionesTipoVisitaWeb)
    /*
    if ( this.configuracion.tipoVisitaIncidenciaWeb.includes('1') &&  this.configuracion.promocionesTipoVisitaWeb.preVenta.length == 0 ) {
      this.configuracion.promocionesTipoVisitaWeb.preVenta = this.$store.state.incidencias.promociones
    }
    if ( this.configuracion.tipoVisitaIncidenciaWeb.includes('2') &&  this.configuracion.promocionesTipoVisitaWeb.postVenta.length == 0 ) {
      this.configuracion.promocionesTipoVisitaWeb.postVenta = this.$store.state.incidencias.promociones
    }
    if ( this.configuracion.tipoVisitaIncidenciaWeb.includes('3') &&  this.configuracion.promocionesTipoVisitaWeb.preEntrega.length == 0 ) {
      this.configuracion.promocionesTipoVisitaWeb.preEntrega = this.$store.state.incidencias.promociones
    }
      */
  },
  watch: {
    cambiado (/* val */) {
      // this.$emit('cambiado', val)
    },
    'configuracion.desdeTerminadoWeb' () {
      if(this.configuracion.desdeTerminadoWeb) {
        this.desactivarVistoBuenoCliente()
      }
    },
    'configuracion.configVistoBuenoClienteWeb' () {
      if(this.configuracion.configVistoBuenoClienteWeb) {
        this.desactivarTerminada()
      }
    },
    'configuracion.habilitarOpcionesConformidadWeb' () {
      if(this.configuracion.habilitarOpcionesConformidadWeb === false) {
        this.desactivarVistoBuenoCliente()
        this.desactivarTerminada()
      }
    },
    'configuracion.clientesVer' () {
      if(this.configuracion.clientesVerWeb=== false) {
        this.desactivarTodo()
      }
    },
    'configuracion.clientesVerWeb' () {
      if(this.configuracion.clientesVerWeb === false) {
        this.desactivarTodo()
      }
    }
  }
}
</script>

<style scoped>
.iconSize {
  width: 16px !important;
}

.contenedorTextField {
  margin-left: 5px;
  width: 30px;
  display:inline-block;
}

.v-text-field__details{
  display:none;
}
</style>
